/**
 * Resolves the API base URL.
 *
 * On the custom production domain (https://skogskalkyl.se) the frontend MUST
 * call the backend same-origin via the Kubernetes ingress `/api/*` route.
 * That avoids cross-origin CORS preflight, third-party-cookie blocking
 * (Safari ITP, Firefox ETP, Brave), and Cloudflare bot-challenge edge cases
 * that the build-baked emergent.host URL is fragile against.
 *
 * Everywhere else (preview, development) we keep the existing behaviour and
 * use the build-time REACT_APP_BACKEND_URL.
 */
const SAME_ORIGIN_HOSTS = new Set([
  'skogskalkyl.se',
  'www.skogskalkyl.se',
]);

export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (SAME_ORIGIN_HOSTS.has(host)) {
      return '';
    }
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Pre-resolved constant for easy drop-in replacement of
//   `const API_URL = process.env.REACT_APP_BACKEND_URL || '';`
export const API_BASE_URL = getApiBaseUrl();

// Lightweight debug helper – logs once in dev or when ?debug=api is in URL.
// In production this is silent, but the resolved base URL stays inspectable
// at window.__apiBaseUrl for support purposes.
if (typeof window !== 'undefined') {
  window.__apiBaseUrl = API_BASE_URL || '(same-origin)';
  const isDebug = window.location.search.includes('debug=api');
  if (process.env.NODE_ENV !== 'production' || isDebug) {
    // eslint-disable-next-line no-console
    console.info('[skogskalkyl] API base URL:', window.__apiBaseUrl);
  }
}

export default API_BASE_URL;
